module.exports = __webpack_public_path__ + "static/wallet-image-1f98fd986e48495881590feb237a7fda.svg";